const STUDENT_APP_PREFIX = 'student';
const TEACHER_APP_PREFIX = 'teacher';
const B2C_LOGIN_APP_PREFIX = 'code';

const subDomainMapping = {
    teacherApp: {
        prod: [TEACHER_APP_PREFIX],
        preProd: [`${TEACHER_APP_PREFIX}-preprod`],
        staging: [`${TEACHER_APP_PREFIX}-staging`],
        dev: [`${TEACHER_APP_PREFIX}-dev`],
    },
    studentApp: {
        prod: [STUDENT_APP_PREFIX],
        preProd: [`${STUDENT_APP_PREFIX}-preprod`],
        staging: [`${STUDENT_APP_PREFIX}-staging`],
        dev: [`${STUDENT_APP_PREFIX}-dev`],
    },
}

const environments = {
    dev: 'dev',
    staging: 'staging',
    preProd: 'preprod',
    production: 'production'
}

const teacherAppSubDomains = Object.values(subDomainMapping.teacherApp).flat();

const studentAppSubDomains = Object.values(subDomainMapping.studentApp).flat();

const appSubdomains = Object.keys(subDomainMapping).map(platform => Object.values(subDomainMapping[platform]).flat()).flat();

const rootDomains = [
    'dev',
    'www',
    'school',
    'staging',
    'preprod',
    'localhost',
    'tekie-web-dev',
    'tekie-web-staging',
    'tekie-web-pre-prod',
    'web-staging-8db1f1b3f3b32bfd',
];

const routeType = { PUBLIC: 'PUBLIC', PRIVATE: 'PRIVATE' }

export {
  STUDENT_APP_PREFIX,
  TEACHER_APP_PREFIX,
  B2C_LOGIN_APP_PREFIX,
  subDomainMapping,
  teacherAppSubDomains,
  studentAppSubDomains,
  appSubdomains,
  rootDomains,
  environments,
  routeType
};